module.exports = __webpack_public_path__ + "img/latest-result-banner-bg-4.487112bf.webp";